import { Typography } from '@eye-able/ui';
import { T } from '@/i18n/T';

export function CustomPolicyHeader() {
  return (
    <div>
      <Typography tag='h1' variant='headline-xl'>
        <T k='customPolicies' />
      </Typography>
      <Typography className='eye:mt-5xs eye:text-grey-120'>
        <T k='customPoliciesDescription' />
      </Typography>
    </div>
  );
}
